import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios, { all } from "axios";
import { Link, useOutletContext, useSearchParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../utils/decodeHtml";
import InvoiceStatusCell from "../client/InvoiceStatusCell";
import { currency_converter_inr } from "../../utils/currencyUtils";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import useSmartBack from "../../hooks/useSmartBack";


function Outstanding() {
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const REACT_APP_BASE_URL = process.env.REACT_APP_BASE_URL;
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const [searchParams] = useSearchParams();
  const { setGlobalLoading, token } = useOutletContext();
  const [clientOptions, setClientOptions] = useState([]);
  const [yearlyOptions, setYearlyOptions] = useState([]);

  const [showBuHeadModal, setShowBuHeadModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedOwner, setSelectedOwner] = useState("");

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const searchUserId = searchParams.get("user_id");  
  const handleBack = useSmartBack("/account/index");
  const passedUser = searchUserId
    ? {
        id: searchUserId,
        firstname: searchParams.get("firstname"),
        lastname: searchParams.get("lastname"),
      }
    : null;
  
  const [selectedUser, setSelectedUser] = useState( passedUser || {
    id: null,
    firstname: "Firm",
    lastname: "Wide",
  }
);
  const [userList, setUserList] = useState([]);
  const {
    register,
    setValue,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [data, setData] = useState([]);
  const [options, setoptions] = useState([]);
  const [selectedYear, setSelectedYear] = useState(""); // e.g., "2025-2026"
  const id = user.id;
  useEffect(() => {

      const getBasicDetails = async () => {
        try {
          setGlobalLoading(true);
          const response = await axios.get(
            `${REACT_APP_API_BASE_URL}/accounts/user_details`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          setUserList(response.data);

     if (response.data?.user?.length > 0) {

        // If user came from Overview page
        if (passedUser) {
          setSelectedUser(passedUser);
          setValue("user_id", passedUser.id);
          return;
        }

        setSelectedUser({
          id: null,
          firstname: "Firm",
          lastname: "Wide",
        });

        setValue("user_id", null);
      }
        } catch (error) {
          console.log(error);
          setGlobalLoading(false);
        } finally {
          setGlobalLoading(false);
        }
      };
      getBasicDetails();
    }, []);

  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };

  const selectedUserId = selectedUser?.id ?? null;
  const get_outstanding_data = async () => {
  try {
    setGlobalLoading(true);

    const userId = selectedUserId ? selectedUserId : '';

    const response = await axios.get(
      `${REACT_APP_API_BASE_URL}/accounts/get_outstanding_data`, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          user_id: userId,
        },
    });

    const d = response.data;

    if (response.status === 200) {
      setClientOptions(response.data.outstanding_clients || []);
      setYearlyOptions(response.data.outstanding_yearly || []);
      setData({
        ...d,
        current_outstanding:
          d?.outstanding_current_year?.[0]?.sum || 0,
        prev_outstanding:
          d?.outstanding_prev_year?.[0]?.sum || 0,
      });

      setoptions(d?.outstanding_invoice_items_list || []);
    }
  } catch (error) {
    console.error(error);
  } finally {
    setGlobalLoading(false);
  }
  };

  useEffect(() => {
    get_outstanding_data();
  }, [selectedUserId]);

  const updateBuHead = async () => {
    try {
      // if (!selectedOwner || !selectedRole?.role_id) {
      //   alert("Please select a BU Head");
      //   return;
      // }

      setGlobalLoading(true);

      const response = await axios.post(
        `${REACT_APP_API_BASE_URL}/accounts/update_role_owner`,
        {
          id: selectedRole.id,
          role_id: selectedRole.role_id,
          ownership: selectedOwner,
          accounts_comment: selectedRole?.accounts_comment || "",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        setShowBuHeadModal(false);
        get_outstanding_data();
      }
    } catch (error) {
      console.error(error);
    } finally {
      setGlobalLoading(false);
    }
  };

  const columns = [
    {
      accessorKey: "retainer",
      header: "Retainer",
      size: 50,
       Cell: ({ row }) => {
                const text = decodeHtml(row.original.retainer || "");
                return (
                  <Link
                    to={`/order/view/${row.original.invoice_id}`}
                    title={text}
                  >
                    {text.length > 25 ? `${text.substring(0, 25)}...` : text}
                  </Link>
                );
              },
    },
    {
      accessorKey: "roles",
      header: "Role Name",
      size: 50,
      Cell: ({ row }) => {
                const text = decodeHtml(row.original.roles || "");
                return (
                  <Link to={`/role/view/${row.original.role_id}`}
                    title={text}
                  >
                    {text.length > 26 ? `${text.substring(0, 26)}...` : text}
                  </Link>
                );
              },
    },
    {
      accessorKey: "client",
      header: "Clients",
      size: 50,
      Cell: ({ row }) => {
                const text = decodeHtml(row.original.client || "");
                return (
                  <Link title={text}>
                    {text.length > 25 ? `${text.substring(0, 25)}...` : text}
                  </Link>
                );
              },
    },
    {
      accessorKey: "bu_head",
      header: "Ownership",
      size: 70,
      Cell: ({ row }) => (
        <button
          type="button"
          className="btn btn-link p-0 text-decoration-none"
          onClick={() => {
            setSelectedRole(row.original);
            setSelectedOwner(row.original.ownership || "");
            setShowBuHeadModal(true);
          }}
        >
          {row.original.bu_head || "Assign BU Head"}
        </button>
      ),
    },
    {
      accessorKey: "role_manager",
      header: "Role Manager",
      size: 70,
    },
    {
      accessorKey: "business_developed",
      header: "Business Developed",
      size: 70,
    },
    {
      accessorKey: "entity",
      header: "Entity",
      size: 40,
    },
    {
      accessorKey: "status",
      header: "Status",
      size: 40,
    },
    {
      accessorKey: "invoice_number",
      header: "Invoice Number",
      size: 70,
    },
    {
      accessorKey: "issue_date",
      header: "Issue Date",
      size: 70,
    },
    {
      accessorKey: "due_date",
      header: "Due Date",
      size: 70,
    },
    {
      accessorKey: "days",
      header: "Days",
      size: 50,
    },
    {
      accessorKey: "financial_year",
      header: "Financial Year",
      size: 70,
    },
    {
      accessorKey: "invoice_amount",
      header: "Invoice Amount",
      size: 70,
    },
    {
      accessorKey: "amount_inr",
      header: "Amount(INR)",
      size: 70,
      Cell: ({ row }) => currency_converter_inr(row.original.amount_inr),
    },
    {
      accessorKey: "taxable_amount",
      header: "Taxable Amount",
      size: 70,
      Cell: ({ row }) => currency_converter_inr(row.original.taxable_amount),
    },
    {
      accessorKey: "accounts_comment",
      header: "Comments",
      size: 70,
    },
  ];

  const exportToExcel = () => {
    const exportData = options.map((item) => ({
      "Role Name": item.roles,
      Client: item.client,
      Retainer: item.retainer,
      "BU Head": item.bu_head,
      "Business Developed": item.business_developed,
      Entity: item.entity,
      Status: item.status,
      "Invoice Number": item.invoice_number,
      "Issue Date": item.issue_date,
      "Due Date": item.due_date,
      Days: item.days,
      "Invoice Amount": item.invoice_amount,
      "Amount (INR)": item.amount_inr,
      "Taxable Amount": item.taxable_amount,
      "Financial Year": item.financial_year,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Outstanding Invoices"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(
      fileData,
      `Outstanding_Invoices_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`
    );
  };

  const exportClientSummaryExcel = () => {
    const exportData = clientOptions.map((row) => ({
      Client: row.client,
      Closure: row.Closure || 0,
      "On Hold": row.OnHold || 0,
      Retainer: row.Retainer || 0,
      Shelved: row.Shelved || 0,
      "Grand Total": row.GrandTotal || 0,
    }));

    exportData.push({
      Client: "GRAND TOTAL",
      Closure: grandClientTotal.Closure,
      "On Hold": grandClientTotal.OnHold,
      Retainer: grandClientTotal.Retainer,
      Shelved: grandClientTotal.Shelved,
      "Grand Total": grandClientTotal.GrandTotal,
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    worksheet["!cols"] = [
      { wch: 35 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 18 },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Clientwise Outstanding"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(
      fileData,
      `Clientwise_Outstanding_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`
    );
  };

  const exportYearSummaryExcel = () => {
    const exportData = yearlyOptions.map((row) => ({
      Year: row.financial_year,
      Closure: row.Closure || 0,
      "On Hold": row.OnHold || 0,
      Retainer: row.Retainer || 0,
      Shelved: row.Shelved || 0,
      "Grand Total": row.GrandTotal || 0,
    }));

    exportData.push({
      Year: "GRAND TOTAL",
      Closure: grandClientTotal.Closure,
      "On Hold": grandClientTotal.OnHold,
      Retainer: grandClientTotal.Retainer,
      Shelved: grandClientTotal.Shelved,
      "Grand Total": grandClientTotal.GrandTotal,
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);

    worksheet["!cols"] = [
      { wch: 35 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 15 },
      { wch: 18 },
    ];

    const workbook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(
      workbook,
      worksheet,
      "Yearwise Outstanding"
    );

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const fileData = new Blob([excelBuffer], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });

    saveAs(
      fileData,
      `Yearwise_Outstanding_${new Date()
        .toISOString()
        .slice(0, 10)}.xlsx`
    );
  };

  const grandClientTotal = clientOptions.reduce(
    (acc, row) => {
      acc.Closure += Number(row.Closure || 0);
      acc.OnHold += Number(row.OnHold || 0);
      acc.Retainer += Number(row.Retainer || 0);
      acc.Shelved += Number(row.Shelved || 0);
      acc.GrandTotal += Number(row.GrandTotal || 0);
      return acc;
    },
    {
      Closure: 0,
      OnHold: 0,
      Retainer: 0,
      Shelved: 0,
      GrandTotal: 0,
    }
  );

  const grandYearTotal = yearlyOptions.reduce(
    (acc, row) => {
      acc.Closure += Number(row.Closure || 0);
      acc.OnHold += Number(row.OnHold || 0);
      acc.Retainer += Number(row.Retainer || 0);
      acc.Shelved += Number(row.Shelved || 0);
      acc.GrandTotal += Number(row.GrandTotal || 0);
      return acc;
    },
    {
      Closure: 0,
      OnHold: 0,
      Retainer: 0,
      Shelved: 0,
      GrandTotal: 0,
    }
  );  

  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">Outstanding Invoices</h2>
          </div>
          <div className="mb-3 d-flex align-items-center">
            <button className="btn btn-light btn-sm" onClick={handleBack}>
                <i className="fa-solid fa-arrow-left me-1"></i> Back to Accounts
            </button>
            <button
              className="btn btn-success btn-sm mx-2"
              onClick={exportToExcel}
            >
              <i className="fa-solid fa-file-excel me-1"></i>
              Export Excel
            </button>
            <div className="dropdown">
              <button
                className="btn btn-light dropdown-toggle"
                type="button"
                data-bs-toggle={'dropdown'}
              >
                {selectedUser
                  ? `${selectedUser.firstname} ${selectedUser.lastname}`
                  : "Select User"}
              </button>

              <ul className="dropdown-menu">

                <li>
                  <button
                    className="dropdown-item"
                    onClick={() => {
                      setSelectedUser({
                        id: null,
                        firstname: "Firm",
                        lastname: "Wide",
                      });

                      setValue("user_id", null);
                    }}
                  >
                    Firm Wide
                  </button>
                </li>

                {userList?.user?.map((item) => (
                  <li key={item.id}>
                    <button
                      className="dropdown-item"
                      onClick={() => {
                        setSelectedUser(item);
                        setValue("user_id", item.id);
                      }}
                    >
                      {item.firstname} {item.lastname}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="card border-0">
          <div className="row">
            <div className="col-xxl-12 d-flex">
              <div className="row flex-fill">
                <div className="col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <h3
                        className="d-flex fs-17 mb-2"
                        style={{ flexDirection: "row" }}
                      >
                        <span className="avatar rounded-circle bg-purple mb-1 me-2">
                          <i className="fa-solid fa-money-bills"></i>
                        </span>
                        <div
                          className="d-flex"
                          style={{
                            flexDirection: "column",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <span className="fw-lighter">Total Outstanding</span>
                          <span>
                            {currency_converter_inr(
                              data?.outstanding_current_year?.[0]?.revenue,
                            )}
                          </span>
                        </div>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex">
                  <div className="card flex-fill div-focus-border">
                    <div className="card-body">
                      <h3
                        className="d-flex fs-17 mb-3"
                        style={{ flexDirection: "row" }}
                      >
                        <span className="avatar rounded-circle bg-pink mb-1 me-2">
                          <i className="fa-solid fa-file-invoice"></i>
                        </span>
                        <div
                          className="d-flex"
                          style={{
                            flexDirection: "column",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <span className="fw-lighter">Sent Invoices</span>
                          <span>
                            {data?.outstanding_current_year?.[0]?.invoiceCount}
                          </span>
                        </div>
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <h3
                        className="d-flex fs-17 mb-3"
                        style={{ flexDirection: "row" }}
                      >
                        <span className="avatar rounded-circle bg-warning mb-1 me-2">
                          <i className="fa-solid fa-clock"></i>
                        </span>
                        <div
                          className="d-flex"
                          style={{
                            flexDirection: "column",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <span className="fw-lighter">India Invoices</span>
                          <span>
                            {" "}
                            {
                              data?.outstanding_current_year?.[0]
                                ?.india_invoice_count
                            }
                          </span>
                        </div>
                      </h3>
                      <div className="d-flex align-items-center">
                        <span className="fw-10">
                          Outstanding:{" "}
                          {currency_converter_inr(
                            data?.outstanding_current_year?.[0]?.india_revenue,
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-3 d-flex">
                  <div className="card flex-fill">
                    <div className="card-body">
                      <h3
                        className="d-flex fs-17 mb-3"
                        style={{ flexDirection: "row" }}
                      >
                        <span className="avatar rounded-circle bg-secondary mb-1 me-2">
                          <i className="fa-solid fa-plane"></i>
                        </span>
                        <div
                          className="d-flex"
                          style={{
                            flexDirection: "column",
                            justifyContent: "space-evenly",
                          }}
                        >
                          <span className="fw-lighter">
                            International Invoices
                          </span>
                          <span>
                            {
                              data?.outstanding_current_year?.[0]
                                ?.international_invoice_count
                            }
                          </span>
                        </div>
                      </h3>
                      <div className="d-flex align-items-center">
                        <span className="fw-10">
                          Outstanding:{" "}
                          {currency_converter_inr(
                            data?.outstanding_current_year?.[0]
                              ?.international_revenue,
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        
          <div className="row">
            <div className="col-md-12 col-xl-12 col-xxl-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">Clientwise Outstanding Summary</h4>
                  <button className="btn btn-success btn-sm" onClick={exportClientSummaryExcel}>
                    <i className="fa-solid fa-file-excel me-1"></i>
                    Download Summary
                  </button>
                </div>

                <div className="card-body">
                      <div className="table-responsive" style={{ maxHeight: "500px" }}>
                      <table className="table text-nowrap table-bordered">
                          <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                          <tr>
                              <th>Client</th>
                              <th>Closure</th>
                              <th>On Hold</th>
                              <th>Retainer</th>
                              <th>Shelved</th>
                              <th>Grand Total</th>
                          </tr>
                          </thead>

                          <tbody>
                          {clientOptions.map((row, index) => (
                              <tr>
                              <td>{row.client}</td>
                              <td>{formatNumber(row.Closure)}</td>
                              <td>{formatNumber(row.OnHold)}</td>
                              <td>{formatNumber(row.Retainer)}</td>
                              <td>{formatNumber(row.Shelved)}</td>
                              <td>{formatNumber(row.GrandTotal)}</td>
                             </tr>
                          ))}
                          </tbody>

                          <tfoot
                          style={{
                              position: "sticky",
                              bottom: 0,
                              background: "#fff",
                              fontWeight: "bold",
                              zIndex: 1,
                          }}
                          >
                          <tr style={{ background: "#f1f1f1" }}>
                              <td>Grand Total</td>
                              <td>{formatNumber(grandClientTotal.Closure)}</td>
                              <td>{formatNumber(grandClientTotal.OnHold)}</td>
                              <td>{formatNumber(grandClientTotal.Retainer)}</td>
                              <td>{formatNumber(grandClientTotal.Shelved)}</td>
                              <td>{formatNumber(grandClientTotal.GrandTotal)}</td>
                          </tr>
                          </tfoot>
                      </table>
                      </div>        
                  </div>
              </div>
          </div>
          </div> 

          <div className="row">
            <div className="col-md-12 col-xl-12 col-xxl-12">
              <div className="card">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="mb-0">Yearwise Outstanding Summary</h4>
                  <button className="btn btn-success btn-sm" onClick={exportYearSummaryExcel}>
                    <i className="fa-solid fa-file-excel me-1"></i>
                    Download Summary
                  </button>
                </div>

                <div className="card-body">
                      <div className="table-responsive" style={{ maxHeight: "500px" }}>
                      <table className="table text-nowrap table-bordered">
                          <thead className="table-dark" style={{ position: "sticky", top: 0, zIndex: 1 }}>
                          <tr>
                              <th>Year</th>
                              <th>Closure</th>
                              <th>On Hold</th>
                              <th>Retainer</th>
                              <th>Shelved</th>
                              <th>Grand Total</th>
                          </tr>
                          </thead>

                          <tbody>
                          {yearlyOptions.map((row, index) => (
                              <tr>
                              <td>{row.financial_year}</td>
                              <td>{formatNumber(row.Closure)}</td>
                              <td>{formatNumber(row.OnHold)}</td>
                              <td>{formatNumber(row.Retainer)}</td>
                              <td>{formatNumber(row.Shelved)}</td>
                              <td>{formatNumber(row.GrandTotal)}</td>
                             </tr>
                          ))}
                          </tbody>

                          <tfoot
                          style={{
                              position: "sticky",
                              bottom: 0,
                              background: "#fff",
                              fontWeight: "bold",
                              zIndex: 1,
                          }}
                          >
                          <tr style={{ background: "#f1f1f1" }}>
                              <td>Grand Total</td>
                              <td>{formatNumber(grandYearTotal.Closure)}</td>
                              <td>{formatNumber(grandYearTotal.OnHold)}</td>
                              <td>{formatNumber(grandYearTotal.Retainer)}</td>
                              <td>{formatNumber(grandYearTotal.Shelved)}</td>
                              <td>{formatNumber(grandYearTotal.GrandTotal)}</td>
                          </tr>
                          </tfoot>
                      </table>
                      </div>        
                  </div>
              </div>
          </div>
          </div>

          {showBuHeadModal && (
            <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
              <div className="modal-dialog modal-md">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Update Ownership
                    </h5>

                    <button type="button" className="btn-close" onClick={() => setShowBuHeadModal(false)}></button>
                  </div>
                  <div className="modal-body">
                    <div className="mb-3">
                      <label className="form-label">Role</label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedRole?.roles || ""}
                        disabled
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Select Ownership</label>

                      <select
                        className="form-select"
                        value={selectedOwner}
                        onChange={(e) => setSelectedOwner(e.target.value)}
                      >
                        <option value="">Select User</option>

                        {userList?.user?.map((user) => (
                          <option key={user.id} value={user.id}>
                            {user.firstname} {user.lastname}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="mb-3">
                      <label className="form-label">Accounts Comments</label>
                      <textarea
                        className="form-control"
                        rows={3}
                        value={selectedRole?.accounts_comment || ""}
                        onChange={(e) =>
                          setSelectedRole({
                            ...selectedRole,
                            accounts_comment: e.target.value,
                          })
                        }
                      />
                    </div>

                  </div>

                  <div className="modal-footer">
                    <button className="btn btn-secondary btn-sm me-3" onClick={() => setShowBuHeadModal(false)}>
                      Cancel
                    </button>

                    <button className="btn btn-primary btn-sm" onClick={updateBuHead}>
                      Save
                    </button>
                  </div>

                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="card">
              <div className="card-body p-0">
                <div className="custom-datatable-filter table-responsive">
                  <div className="row p-4 mt-3">
                    <div className="row mb-3">
                      <div className="col-md-3">
                        <div className="alert alert-primary py-2 mb-0">
                          <strong>Total Records:</strong> {options.length}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div className="alert alert-success py-2 mb-0">
                          <strong>Total Outstanding:</strong>{" "}
                          {currency_converter_inr(grandClientTotal.GrandTotal)}
                        </div>
                      </div>
                      <div className="col-md-4 text-end">
                        <button className="btn btn-success btn-sm mx-2" onClick={exportToExcel}>
                          <i className="fa-solid fa-file-excel me-1"></i>
                          Export Excel
                        </button>
                      </div>  

                    </div>
                    {options.length > 0 && (
                      <MaterialReactTable
                        columns={columns}
                        data={options}
                        enableGrouping
                        initialState={{
                          density: "compact",
                          grouping: ["client"], // group by company_name
                          expanded: true, // expand groups by default
                          pagination: { pageSize: 100 },
                          columnOrder: [
                            "roles",
                            "client",
                            "retainer",
                            "bu_head",
                            "role_manager",
                            "business_developed",
                            "entity",
                            "status",
                            "invoice_number",
                            "issue_date",
                            "due_date",
                            "days",
                            "invoice_amount",
                            "amount_inr",
                            "taxable_amount",
                            "financial_year",
                            "accounts_comment"
                          ],
                          columnPinning: {
                            left: [], // 👈 no pinned columns
                            right: [],
                          },
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Outstanding;
